export interface Comic {
  id: string;
  title: string;
  category: string;
  categoryId: string;
  tags: string[];
  status: string;
  author: string;
  views: string;
  hotScore: number;
  rating: number;
  chapters: number;
  updateTime: string;
  description: string;
  cover: string;
  featured?: boolean;
  isNew?: boolean;
}

export interface Category {
  id: string;
  name: string;
  tagline: string;
  desc: string;
  count: string;
  icon: string;
}

export const categories: Category[] = [
  {
    id: "zunxiang",
    name: "尊享漫画",
    tagline: "殿堂级典藏",
    desc: "精挑细选的高分神作，专属会员尊贵典藏，超高画质与完整剧情并重。",
    count: "128部",
    icon: "ri-vip-crown-line",
  },
  {
    id: "zuanshi",
    name: "钻石漫画",
    tagline: "至臻之作",
    desc: "如钻石般璀璨的顶尖作品，独占首发与独家番外，稀缺内容专享。",
    count: "96部",
    icon: "ri-vip-diamond-line",
  },
  {
    id: "guizu",
    name: "贵族漫画",
    tagline: "雅贵风范",
    desc: "偏向精致画风与深度剧情的贵族气派作品，沉浸式阅读体验。",
    count: "74部",
    icon: "ri-award-line",
  },
  {
    id: "haohua",
    name: "豪华漫画",
    tagline: "奢华体验",
    desc: "豪华画质与震撼分镜的视听盛宴，超大屏专属阅读享受。",
    count: "52部",
    icon: "ri-magic-line",
  },
];

export const comics: Comic[] = [
  {
    id: "longyuan",
    title: "龙渊之巅",
    category: "尊享漫画",
    categoryId: "zunxiang",
    tags: ["玄幻热血", "逆袭王者", "龙族"],
    status: "连载中",
    author: "墨渊工作室",
    views: "2.8亿",
    hotScore: 98,
    rating: 9.6,
    chapters: 326,
    updateTime: "2小时前更新",
    description:
      "少年萧尘身负上古龙渊血脉，在家族至暗时刻觉醒真龙之力。面对龙族强敌与诸天霸主，他一路逆天而上，执剑问天，登临万界之巅，书写一代龙帝的不朽传奇。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20luxury%20fantasy%20comic%20cover%20art%2C%20a%20young%20warrior%20holding%20a%20glowing%20golden%20dragon%20sword%2C%20gold%20and%20black%20palette%2C%20divine%20golden%20dragon%20spiraling%20behind%20him%2C%20epic%20xianxia%20atmosphere%2C%20cinematic%20lighting%2C%20intricate%20detail%2C%20premium%20manhua%20illustration%20style&width=600&height=800&seq=cover-longyuan&orientation=portrait",
    featured: true,
  },
  {
    id: "jianqi",
    title: "剑起苍穹",
    category: "尊享漫画",
    categoryId: "zunxiang",
    tags: ["仙侠修仙", "剑道", "天骄"],
    status: "连载中",
    author: "青峰动漫",
    views: "1.9亿",
    hotScore: 95,
    rating: 9.4,
    chapters: 268,
    updateTime: "4小时前更新",
    description:
      "剑修陈玄生而平凡，却以凡人之躯立志登顶剑道之巅。一朝悟得无上剑意，从微末之地位列苍穹天骄，一路斩妖诛魔，开辟属于剑修的至尊大道。",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20sword%20cultivator%20comic%20cover%2C%20a%20white-robed%20young%20swordsman%20pointing%20a%20luminous%20sword%20to%20the%20sky%2C%20golden%20and%20deep%20black%20palette%2C%20floating%20swords%20in%20sky%2C%20dramatic%20clouds%2C%20premium%20manhua%20art%2C%20cinematic%20and%20majestic&width=600&height=800&seq=cover-jianqi&orientation=portrait",
    featured: true,
  },
  {
    id: "jiulong",
    title: "九龙夺嫡",
    category: "钻石漫画",
    categoryId: "zuanshi",
    tags: ["玄幻热血", "王朝争霸", "龙脉"],
    status: "连载中",
    author: "九龙动漫社",
    views: "2.4亿",
    hotScore: 97,
    rating: 9.5,
    chapters: 358,
    updateTime: "1小时前更新",
    description:
      "神朝九龙并立，太子之位悬而未决。身负九龙神脉的九皇子以局外之姿入局，翻云覆雨，搅动王朝气运，在九龙夺嫡的血雨腥风中问鼎至高帝位。",
    cover:
      "https://readdy.ai/api/search-image?query=Majestic%20imperial%20fantasy%20comic%20cover%2C%20nine%20golden%20dragons%20soaring%20around%20a%20young%20emperor%20figure%2C%20black%20and%20gold%20palette%2C%20royal%20palace%20and%20throne%2C%20epic%20dynasty%20war%20atmosphere%2C%20premium%20manhua%20illustration&width=600&height=800&seq=cover-jiulong&orientation=portrait",
    featured: true,
  },
  {
    id: "wangup",
    title: "万古神王",
    category: "尊享漫画",
    categoryId: "zunxiang",
    tags: ["玄幻热血", "神格", "霸体"],
    status: "连载中",
    author: "神王绘卷",
    views: "3.1亿",
    hotScore: 99,
    rating: 9.7,
    chapters: 412,
    updateTime: "3小时前更新",
    description:
      "少年逆天改命，觉醒万古不灭的神王霸体。从一介废材到诸天第一神王，他以铁血与柔情守护所爱之人，在万古长河中留下不朽传说。",
    cover:
      "https://readdy.ai/api/search-image?query=Legendary%20god%20king%20comic%20cover%2C%20muscular%20hero%20in%20dark%20gold%20armor%20with%20radiant%20divine%20aura%2C%20black%20and%20gold%20palette%2C%20galaxy%20and%20flames%20background%2C%20epic%20premium%20manhua%20art%2C%20cinematic&width=600&height=800&seq=cover-wangup&orientation=portrait",
    featured: true,
  },
  {
    id: "xinghai",
    title: "星海霸主",
    category: "钻石漫画",
    categoryId: "zuanshi",
    tags: ["星际科幻", "机甲", "霸主"],
    status: "连载中",
    author: "星海工坊",
    views: "1.2亿",
    hotScore: 90,
    rating: 9.1,
    chapters: 201,
    updateTime: "6小时前更新",
    description:
      "流落星海的无名小卒，意外获得失落的文明引擎。驾驶顶级机甲征战浩瀚星海，从无名小卒成长为让整个银河都为之颤抖的星海霸主。",
    cover:
      "https://readdy.ai/api/search-image?query=Sci-fi%20mecha%20comic%20cover%2C%20a%20heroic%20pilot%20inside%20a%20sleek%20gold%20and%20black%20mecha%2C%20deep%20space%20nebula%20background%2C%20glowing%20energy%20core%2C%20premium%20manhua%20art%2C%20cinematic%20lighting&width=600&height=800&seq=cover-xinghai&orientation=portrait",
    isNew: true,
  },
  {
    id: "xuanyuan",
    title: "轩辕帝尊",
    category: "贵族漫画",
    categoryId: "guizu",
    tags: ["仙侠修仙", "帝尊", "血脉"],
    status: "连载中",
    author: "轩辕画社",
    views: "1.6亿",
    hotScore: 93,
    rating: 9.3,
    chapters: 287,
    updateTime: "5小时前更新",
    description:
      "身怀上古轩辕血脉的少年，继承失落圣器的意志，踏上成帝之路。仙途漫漫，他在爱恨情仇与天地大劫之间，铸就属于自己的帝尊传奇。",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20immortal%20emperor%20comic%20cover%2C%20a%20noble%20young%20immortal%20with%20ancient%20rune%20energy%2C%20black%20gold%20and%20deep%20red%20palette%2C%20mountain%20immortal%20realm%20background%2C%20premium%20manhua%20illustration%2C%20elegant&width=600&height=800&seq=cover-xuanyuan&orientation=portrait",
    featured: true,
  },
  {
    id: "dushi",
    title: "都市隐龙",
    category: "豪华漫画",
    categoryId: "haohua",
    tags: ["都市至尊", "保镖", "逆袭"],
    status: "连载中",
    author: "隐龙动画",
    views: "2.1亿",
    hotScore: 94,
    rating: 9.2,
    chapters: 244,
    updateTime: "2小时前更新",
    description:
      "昔日兵王归隐都市，化身冰山女总裁的贴身保镖。面对明枪暗箭与豪门恩怨，他隐藏锋芒，却在关键时刻一鸣惊人，搅动都市风云。",
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20action%20comic%20cover%2C%20confident%20young%20man%20in%20suit%20beside%20a%20modern%20city%20skyline%20at%20night%2C%20black%20gold%20palette%2C%20city%20lights%2C%20premium%20manhua%20art%2C%20stylish%20and%20dramatic&width=600&height=800&seq=cover-dushi&orientation=portrait",
    isNew: true,
  },
  {
    id: "nitian",
    title: "逆天医仙",
    category: "豪华漫画",
    categoryId: "haohua",
    tags: ["都市至尊", "医道", "神医"],
    status: "连载中",
    author: "医仙阁",
    views: "1.8亿",
    hotScore: 92,
    rating: 9.0,
    chapters: 219,
    updateTime: "7小时前更新",
    description:
      "身怀逆天医术的神医传人回归都市，一双妙手可起死回生。他行医救人、快意恩仇，在名利场与生死局中书写医者仁心的传奇篇章。",
    cover:
      "https://readdy.ai/api/search-image?query=Medical%20master%20comic%20cover%2C%20elegant%20young%20doctor%20with%20glowing%20healing%20energy%2C%20black%20gold%20and%20emerald%20accents%2C%20modern%20city%20background%2C%20premium%20manhua%20art%2C%20refined&width=600&height=800&seq=cover-nitian&orientation=portrait",
  },
  {
    id: "jueshi",
    title: "绝世神皇",
    category: "尊享漫画",
    categoryId: "zunxiang",
    tags: ["玄幻热血", "神皇", "万界"],
    status: "连载中",
    author: "神皇动漫",
    views: "2.6亿",
    hotScore: 96,
    rating: 9.5,
    chapters: 337,
    updateTime: "3小时前更新",
    description:
      "天骄少年跌落神坛，从云端坠入凡尘，却于绝境中再度觉醒。他于万界争锋中步步登顶，最终君临九天，成就旷世神皇之位。",
    cover:
      "https://readdy.ai/api/search-image?query=Supreme%20divine%20emperor%20comic%20cover%2C%20a%20young%20god%20wreathed%20in%20golden%20divine%20flames%20on%20a%20celestial%20throne%2C%20black%20and%20gold%20palette%2C%20nine%20heavens%20clouds%2C%20premium%20manhua%20illustration%2C%20majestic&width=600&height=800&seq=cover-jueshi&orientation=portrait",
  },
  {
    id: "shenyuan",
    title: "深渊主宰",
    category: "钻石漫画",
    categoryId: "zuanshi",
    tags: ["玄幻热血", "黑暗", "主宰"],
    status: "连载中",
    author: "深渊画作",
    views: "1.4亿",
    hotScore: 91,
    rating: 9.0,
    chapters: 198,
    updateTime: "8小时前更新",
    description:
      "被遗弃的少年坠入无底深渊，在黑暗与死寂中炼就绝世邪功。当他重见天日之时，昔日欺辱他的众生，都将臣服于深渊主宰的威严之下。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20abyss%20lord%20comic%20cover%2C%20a%20hooded%20figure%20with%20glowing%20golden%20eyes%20in%20darkness%2C%20black%20and%20gold%20palette%2C%20void%20and%20crimson%20rifts%2C%20premium%20manhua%20art%2C%20mysterious%20and%20powerful&width=600&height=800&seq=cover-shenyuan&orientation=portrait",
    isNew: true,
  },
  {
    id: "shenji",
    title: "神级天骄",
    category: "豪华漫画",
    categoryId: "haohua",
    tags: ["都市至尊", "天骄", "豪少"],
    status: "连载中",
    author: "天骄工坊",
    views: "1.5亿",
    hotScore: 91,
    rating: 9.1,
    chapters: 231,
    updateTime: "5小时前更新",
    description:
      "他是商界神话，亦是武道天骄。豪气干云、我行我素的顶级贵少，在都市的灯红酒绿与刀光剑影之间，走出属于自己的神级之路。",
    cover:
      "https://readdy.ai/api/search-image?query=Luxury%20young%20tycoon%20comic%20cover%2C%20handsome%20young%20man%20in%20a%20premium%20black%20suit%20with%20gold%20watch%2C%20black%20and%20gold%20palette%2C%20city%20luxury%20villa%20background%2C%20premium%20manhua%20art%2C%20refined&width=600&height=800&seq=cover-shenji&orientation=portrait",
    isNew: true,
  },
  {
    id: "qinglian",
    title: "青莲剑仙",
    category: "贵族漫画",
    categoryId: "guizu",
    tags: ["仙侠修仙", "剑仙", "青莲"],
    status: "连载中",
    author: "青莲画坊",
    views: "9800万",
    hotScore: 89,
    rating: 9.0,
    chapters: 176,
    updateTime: "9小时前更新",
    description:
      "一株青莲化形入世，天生通晓剑意。少年剑仙于红尘中历练剑心，以青莲为剑，斩尽邪魔，守一方净土，成就旷世剑仙之名。",
    cover:
      "https://readdy.ai/api/search-image?query=Ethereal%20sword%20immortal%20comic%20cover%2C%20a%20graceful%20young%20cultivator%20amid%20glowing%20blue%20lotus%20and%20sword%20energy%2C%20black%20gold%20palette%20with%20azure%20accents%2C%20misty%20lake%20background%2C%20premium%20manhua%20art%2C%20elegant&width=600&height=800&seq=cover-qinglian&orientation=portrait",
  },
  {
    id: "wanjie",
    title: "万界塔主",
    category: "尊享漫画",
    categoryId: "zunxiang",
    tags: ["玄幻热血", "万界", "塔主"],
    status: "连载中",
    author: "万界动画",
    views: "2.2亿",
    hotScore: 95,
    rating: 9.4,
    chapters: 305,
    updateTime: "4小时前更新",
    description:
      "少年误入万界之塔，获得镇守万界的传承之力。他一路闯塔问道，收纳各界英杰，在万界争锋中登临塔主之位，守护苍生秩序。",
    cover:
      "https://readdy.ai/api/search-image?query=Tower%20lord%20of%20worlds%20comic%20cover%2C%20a%20young%20hero%20standing%20before%20a%20gigantic%20ancient%20golden%20tower%2C%20black%20and%20gold%20palette%2C%20multiple%20worlds%20in%20sky%2C%20premium%20manhua%20illustration%2C%20epic&width=600&height=800&seq=cover-wanjie&orientation=portrait",
    featured: true,
  },
  {
    id: "wangzhe",
    title: "王者归来",
    category: "豪华漫画",
    categoryId: "haohua",
    tags: ["都市至尊", "回归", "复仇"],
    status: "连载中",
    author: "王者工坊",
    views: "1.7亿",
    hotScore: 92,
    rating: 9.2,
    chapters: 256,
    updateTime: "6小时前更新",
    description:
      "隐姓埋名的绝世王者，十年后携一身盖世修为强势归来。曾经失去的尊严与挚爱，他都要加倍夺回，以王者之姿重新君临都市。",
    cover:
      "https://readdy.ai/api/search-image?query=Return%20of%20the%20king%20comic%20cover%2C%20a%20powerful%20man%20in%20black%20leather%20with%20golden%20aura%20walking%20through%20city%20rain%2C%20black%20and%20gold%20palette%2C%20dramatic%20city%20night%2C%20premium%20manhua%20art%2C%20epic&width=600&height=800&seq=cover-wangzhe&orientation=portrait",
  },
];

export const featuredIds = ["wangup", "longyuan", "jiulong", "jueshi", "wanjie", "xuanyuan"];
export const newIds = ["xinghai", "dushi", "shenji", "shenyuan"];
export const rankingIds = ["wangup", "jiulong", "longyuan", "jueshi", "wanjie", "xuanyuan", "jianqi", "dushi", "wangzhe", "nitian"];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "什么是尊享漫画、钻石漫画等专属漫画内容？",
    a: "尊享漫画、钻石漫画、贵族漫画与豪华漫画是土豪漫画网为专属会员精心筛选的高品质内容分区。尊享漫画汇集殿堂级典藏神作，钻石漫画提供独占首发与稀有番外，贵族漫画主打精致画风与深度剧情，豪华漫画则以超高清画质与震撼分镜呈现视听盛宴。",
  },
  {
    q: "会员专属特权阅读包含哪些权益？",
    a: "成为土豪漫画网会员后，可畅读尊享漫画、钻石漫画、贵族漫画与豪华漫画的全部专属内容，享有抢先看最新章节、豪华画质原图、去广告纯净阅读、专属头像边框与尊贵标识、生日礼包与线下活动优先资格等多重特权。",
  },
  {
    q: "我可以在哪些设备上阅读专属漫画？",
    a: "土豪漫画网支持电脑、平板与手机等多种设备，可在浏览器中直接阅读，无需下载客户端。所有设备均自动同步阅读进度，让你随时随地享受尊贵的专属漫画阅读体验。",
  },
  {
    q: "豪华画质与原画画质有什么区别？",
    a: "豪华画质是土豪漫画网针对大屏设备优化的超高分辨率版本，细节更清晰、色彩更饱满；原画画质则保留作者上传的原始文件，适合对画面有极致追求的会员。尊享会员可在阅读设置中自由切换。",
  },
  {
    q: "会员到期后我的阅读记录会保留吗？",
    a: "会的。你的阅读进度、收藏与书架内容会长期保留，即使会员到期也不会清除。重新开通会员后即可继续畅读专属内容，享受不间断的尊贵阅读体验。",
  },
  {
    q: "如何开通或续费专属会员特权？",
    a: "登录土豪漫画网后，进入「会员特权」页面，选择适合你的会员等级（尊享会员、钻石会员等）并完成开通或续费即可。支持多种便捷支付方式，开通后立即生效。",
  },
];

export interface Testimonial {
  name: string;
  title: string;
  content: string;
  level: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "江先生",
    title: "尊享会员·阅读2年",
    content: "看漫画这么多年，土豪漫画网的尊享专区确实名不虚传。更新快、画质好，钻石漫画的独家番外更是别处看不到的惊喜。",
    level: "尊享会员",
  },
  {
    name: "林公子",
    title: "钻石会员·阅读1年",
    content: "豪华画质在大屏上太震撼了，分镜细腻到每一帧都能细细品味。抢先看最新章节的体验对追更党来说简直不要太友好。",
    level: "钻石会员",
  },
  {
    name: "苏小姐",
    title: "尊享会员·阅读3年",
    content: "贵族漫画区的作品画风都很有格调，剧情也经得起推敲。阅读界面干净纯粹，没有烦人的广告，整体体验非常舒适。",
    level: "尊享会员",
  },
  {
    name: "陈总",
    title: "钻石会员·阅读2年",
    content: "从普通读者一路升级到钻石会员，每一档特权的诚意都感受得到。新年礼包和生日特权很贴心，贵宾感拉满。",
    level: "钻石会员",
  },
];

export interface VipTier {
  name: string;
  price: string;
  period: string;
  color: string;
  icon: string;
  highlight?: string;
  perks: string[];
}

export const vipTiers: VipTier[] = [
  {
    name: "尊享会员",
    price: "¥28",
    period: "/月",
    color: "from-primary-600 to-primary-400",
    icon: "ri-vip-crown-line",
    perks: ["畅读尊享漫画全库", "抢先看最新章节", "豪华画质原图", "去广告纯净阅读"],
  },
  {
    name: "钻石会员",
    price: "¥58",
    period: "/月",
    color: "from-accent-500 to-primary-400",
    icon: "ri-vip-diamond-line",
    highlight: "人气之选",
    perks: ["尊享会员全部权益", "钻石漫画独占首发", "稀有番外专属阅读", "尊贵头像边框标识"],
  },
  {
    name: "贵族会员",
    price: "¥98",
    period: "/月",
    color: "from-secondary-400 to-accent-500",
    icon: "ri-award-line",
    perks: ["钻石会员全部权益", "贵族漫画深度专区", "生日豪礼与专属客服", "线下活动优先资格"],
  },
];